<template>
  <div class="d-flex align-items-center justify-content-end gap-3">
    <!-- <div class="form-check form-switch mb-0">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        id="switch-settings-icons"
        :checked="showIcons"
        @change="$emit('update:showIcons', $event.target.checked)"
      />
      <label
        class="form-check-label"
        for="switch-settings-icons"
      >
        {{ $t("settings.show_icons") }}
      </label>
    </div> -->

    <div class="btn-group">
      <button
        :class="
          'btn btn-primary text-white ' + (viewMode === 'card' ? 'active' : '')
        "
        @click="$emit('update:viewMode', 'card')"
      >
        <font-awesome-icon :icon="['far', 'grid']" />
      </button>
      <button
        :class="
          'btn btn-primary text-white ' + (viewMode === 'list' ? 'active' : '')
        "
        @click="$emit('update:viewMode', 'list')"
      >
        <font-awesome-icon :icon="['far', 'list']" />
      </button>
    </div>

    <button
      v-if="showNewButton"
      class="btn btn-primary text-white text-nowrap"
      @click="$emit('new-tool')"
    >
      <font-awesome-icon
        class="me-2"
        :icon="['far', 'plus']"
      />
      {{ $t("settings.new_tool") }}
    </button>
  </div>
</template>

<script>
  export default {
    name: "ToolToolbar",
    props: {
      showIcons: {
        type: Boolean,
        default: false,
      },
      viewMode: {
        type: String,
        default: "card",
        validator: (value) => ["card", "list"].includes(value),
      },
      showNewButton: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:showIcons", "update:viewMode", "new-tool"],
  };
</script>
